export default __webpack_public_path__ + "static/media/thumb1.0bfc5caa.png";